export default __webpack_public_path__ + "static/Payments-8fb7dc6bc3585e4167c7fde6ed0c3db7.mp4";